import { setCustomer } from './customer';
import { setFeedback, delayedClearFeedback, clearFeedback } from './feedback';

export function handleCustomerResponse(result, message) {
    return [
      setCustomer( result.body ),
      setFeedback( message ),
      delayedClearFeedback()
    ];
 }



// WEBPACK FOOTER //
// ./src/modules/helper_actions.js